function configNotificacoes() {
	/*
	-- Notificações
	*/

	$('.notificacoes__icone, .notificacoes__item-fechar').click(function() {
		$('.notificacoes__lista').toggle();
	});

	$('.notificacoes__fechar').click(function() {
		let num = parseInt($('.notificacoes__num').text());
		let msg_id = $(this).parent().attr('data-id');

		num = num - 1;

		// marca notificação como lida
		notificacao_ler(msg_id);

		if(num == 0) {
			$('.notificacoes__num').text(num).fadeOut();
			$('.notificacoes__lista').prepend('<li class="notificacoes__item"><div class="notificacoes__conteudo">Você não tem notificações no momento.</div></li>').hide();
		} else {
			$('.notificacoes__num').text(num);
		}

		$(this).parent().fadeOut();
	});

	function notificacao_ler(msg_id) {
		$.post(baseurl + 'admin/notificacoes/arq_msg'
			, {'msg_id': msg_id});
	}
}

export default configNotificacoes
